import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Dialog, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import FormField from '../form-controls/form-field';
import React, { useState } from 'react';
import theme from '../../app/app-theme';
import { RegistrationRequest } from '../../service/model/registration-request.model';
import { getOtp, verifyOtp } from '../../service/registration.service';
import { useAppDispatch } from '../../app/hooks';
import { showNotification } from '../../features/alerts/alert.slice';
import { NotificationType } from '../../shared/enums';
import { CheckCircleOutlineIcon } from '../../shared/icons';
import FormCloseButton from '../form-controls/form-close-button';
import { FormTextField } from '../form-input-field-wrappers/form-controller-inputs/form-text-field';

interface RegistrationFormProps {
    readonly onClose: () => void
}

const style = {
    p: 2,
};

const validationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    address: yup.string(),
    email: yup.string().required("Email is required").email("Not a valid email"),
    contact: yup.string().required("Contact is required"),
});

export type FormValues = yup.InferType<typeof validationSchema>;

const RegistrationForm: React.FC<RegistrationFormProps> = ({ onClose }) => {
    const dispatch = useAppDispatch();
    const [userDetails, setUserDetails] = useState<RegistrationRequest>();
    const [isOtp, setIsOtp] = useState(false);
    const [otp, setOtp] = useState('');
    const [isRegistrationCompleted, setIsRegistrationCompleted] = useState(false);

    const { register, handleSubmit, formState: { errors } } = useForm<FormValues>({
        resolver: yupResolver(validationSchema)
    });

    const onSubmitHandler = async (data: RegistrationRequest) => {
        setUserDetails(data);
        await getOtp(data.email).then(res => {
            if (res) {
                setIsOtp(true);
            }
        }).catch(e => {
            dispatch(
                showNotification({
                    message: e.response.data,
                    type: NotificationType.Error,
                })
            );
        })
    };

    const handleOtpSubmit = async () => {
        if (userDetails) {
            await verifyOtp(userDetails, otp).then(res => {
                if (res) {
                    setIsRegistrationCompleted(true);
                }
            }).catch(e => {
                dispatch(
                    showNotification({
                        message: e.response.data,
                        type: NotificationType.Error,
                    })
                );
            })
        }
    };

    // const getRegister = (name: keyof FormValues, validation?: any): UseFormRegisterReturn => {
    //     return register(name, validation);
    // };

    return (
        <>
            {!isOtp && !isRegistrationCompleted &&
                <Dialog open={true} onClose={onClose} sx={style} fullWidth maxWidth='md'>
                    <DialogTitle sx={{ paddingBottom: 0 }}>Registration Form</DialogTitle>
                    <Box sx={style}>
                        <>
                            <FormCloseButton onClose={onClose} />
                            <form onSubmit={handleSubmit(onSubmitHandler)}>
                                <Grid container direction="row" className="mt-0 my-0" justifyContent='space-between'>
                                    <FormField>
                                        <FormTextField
                                            id="name"
                                            label="Name"
                                            name='name'
                                            errorMessage={errors.name?.message}
                                            register={register}
                                        />
                                    </FormField>
                                    <FormField>
                                        <FormTextField
                                            id="address"
                                            label="Address"
                                            name='address'
                                            errorMessage={errors.address?.message}
                                            register={register}
                                        />
                                    </FormField>
                                    <FormField>
                                        <FormTextField
                                            id="contact"
                                            label="Contact Number"
                                            name='contact'
                                            errorMessage={errors.contact?.message}
                                            register={register}
                                        />
                                    </FormField>
                                    <FormField>
                                        <FormTextField
                                            id="email"
                                            label="Email"
                                            name='email'
                                            errorMessage={errors.email?.message}
                                            register={register}
                                        />
                                    </FormField>
                                </Grid>
                                <Grid container direction="row" justifyContent='end' sx={{ mt: 1 }}>
                                    <Button type="button" variant="contained" sx={{ mr: 1, bgcolor: `${theme.palette.secondary.main}` }} onClick={onClose}>Cancel</Button>
                                    <Button type="submit" variant="contained">Get OTP</Button>
                                </Grid>
                            </form>
                        </>
                    </Box>
                </Dialog>
            }

            {isOtp && !isRegistrationCompleted &&
                <Dialog open={true} onClose={onClose} sx={style} fullWidth maxWidth='xs'>
                    <DialogTitle sx={{ paddingBottom: 0 }}>Enter OTP here</DialogTitle>
                    <Box sx={style}>
                        <>
                            <FormCloseButton onClose={onClose} />
                            <Grid container direction="row" className="mt-0 my-0">
                                <TextField
                                    id="otp"
                                    label="OTP"
                                    fullWidth
                                    value={otp}
                                    onChange={e => setOtp(e.currentTarget.value)}
                                />
                            </Grid>
                            <Grid container direction="row" justifyContent='end' sx={{ mt: 1 }}>
                                <Button type="button" variant="contained" sx={{ mr: 1, bgcolor: `${theme.palette.secondary.main}` }} onClick={() => setIsOtp(false)}>Cancel</Button>
                                <Button type="submit" variant="contained" disabled={otp.length !== 6} onClick={handleOtpSubmit}> Submit </Button>
                            </Grid>
                        </>
                    </Box>
                </Dialog>
            }

            {isRegistrationCompleted &&
                <Dialog open={true} onClose={onClose} sx={style} fullWidth maxWidth='md'>
                    <DialogTitle sx={{ paddingBottom: 0 }}>
                        Registration Completed
                    </DialogTitle>
                    <Box sx={{ p: 3, justifyItems: 'center' }}>
                        <>
                            <FormCloseButton onClose={onClose} />
                            <CheckCircleOutlineIcon color="success" height={20} />
                            <Typography>
                                Your registration has been completed successfully. One of our agents will be in touch with you shortly.
                            </Typography>
                        </>
                    </Box>
                </Dialog>
            }
        </>
    );
}

export default RegistrationForm;